import { createClient } from '@supabase/supabase-js'
import { passwordAuthOptions } from './password-flow'

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined

export const supabase = url && key ? createClient(url, key, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: window.location.pathname !== '/account-password' },
}) : null

// Each password page has an in-memory session and a separate broadcast/storage
// namespace. It cannot read or replace the administrator's portal session.
export function createPasswordClient() {
  return url && key ? createClient(url, key, {
    auth: { ...passwordAuthOptions, storageKey: `koorl-password-${crypto.randomUUID()}` },
  }) : null
}

export const isSupabaseConfigured = Boolean(supabase)
